"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarExcessChangePopupWidget = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var CarExcessChangePopupWidget = /** @class */ (function (_super) {
    __extends(CarExcessChangePopupWidget, _super);
    function CarExcessChangePopupWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CarExcessChangePopupWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.props.isOpen, toggle: this.props.toggle, backdrop: "static" },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.props.toggle, close: React.createElement("button", { className: "btn-close", onClick: this.props.toggle }) },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("img", { className: "d-block mr-3 mb-1 info-icon-selected", src: "/img/Flow-info-selected.svg", alt: "Info icon selected" }),
                        React.createElement("div", { className: "text-blue-2 font-weight-medium" }, "Changing your excess"))),
                React.createElement(reactstrap_1.ModalBody, { className: "pt-0 overflow-auto" },
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "mb-4 mt-3" }, "Your total excess (compulsory + voluntary) is the amount you agree to pay if you make a claim."),
                        React.createElement("div", { className: "mb-4" }, "In the event your vehicle is a total loss (damaged beyond repair or stolen and not recovered), we may not pay you the value of your vehicle due to the amount of excess you've chosen."),
                        React.createElement("div", { className: "font-weight-bold" }, "Given the value of your car, you may need to reconsider the amount of voluntary excess you want to pay."))),
                React.createElement(reactstrap_1.ModalFooter, null,
                    React.createElement("button", { type: "button", className: "btn btn-primary btn-next", onClick: this.props.toggle }, "Ok, I understand")))));
    };
    return CarExcessChangePopupWidget;
}(React.Component));
exports.CarExcessChangePopupWidget = CarExcessChangePopupWidget;
//# sourceMappingURL=CarExcessChangePopupWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/subscription/motor/carExcess/CarExcessChangePopupWidget.js
// module id = 1077
// module chunks = 0